import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

const FaqStyle = styled.div`
h3{
    font-size: 24px;
    b{
        font-weight: 600;
    }
}
  
  p.common-text {
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    font-family: 'Graphik';
  }

  .faq-wrapper {
    padding-top: 99px;
    .container {
    max-width: 1170px !important;
    width: 100%;
}
.inner-div {
    padding: 65px 0 80px;
    @media (max-width:1199px){
        padding: 60px 0 60px;
    }
    h2 {
    margin: 0;
    padding-bottom: 50px;
    font-size: 54px;
    color: #000;
    font-family: 'Graphik';
    font-weight: 400;
    text-align: center;
    @media (max-width:1199px){
        font-size: 48px;
        padding-bottom: 30px;
        line-height: 1.2;
    }
    @media (max-width:767px){
        font-size: 38px;
        padding-bottom: 20px;
    }
}
}
.MuiPaper-root {
    box-shadow: unset !important;
    border-top: 1px solid #b3b3b3;
    border-radius: 0;
    &::before {
    display: none;
}
&:last-child {
    border-bottom: 1px solid #b3b3b3;
}
    .MuiButtonBase-root {
    min-height: 68px !important;
    .MuiAccordionSummary-content {
    margin: 0;
    padding-right: 15px;
}
svg {
    display: none;
}
.MuiAccordionSummary-expandIconWrapper {
    position: relative;
    width: 21px;
    &:after, &:before{
        content: "";
    width: 21px;
    height: 1px;
    background-color: #000;
    position: absolute;
    right: 0;
    left: 0;
    }
    &:after {
    transform: rotate(90deg);
    transition: all 0.5s ease-in-out;
}
&.MuiAccordionSummary-expandIconWrapper.Mui-expanded::after {
    transform: rotate(0deg) !important;
}
}
}
.place-order {
    font-size: 22px;
    line-height: 1.2;
    color: #000000;
    font-weight: 500;
    font-family: 'Graphik';
   
    @media (max-width:1199px){
        font-size: 20px;
    }
  }
}
}

li {
    gap: 21px;
    line-height: 37px;
    padding-left: 30px;
}


`;

const Faq = () => {
    /*const [expanded, setExpanded] = useState(false); // State to track expanded accordion

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };*/

    const [expanded, setExpanded] = useState(null);
    const [subExpanded, setSubExpanded] = useState({});

    const handleMainChange = (panelId) => (event, isExpanded) => {
        setExpanded(isExpanded ? panelId : null);
    };

    const handleSubChange = (parentId, subId) => (event, isExpanded) => {
        setSubExpanded((prevState) => ({
            ...prevState,
            [parentId]: {
                ...prevState[parentId],
                [subId]: isExpanded,
            },
        }));
    };

    const faqs = [
        {
            id: 1,
            question: "<b>Account Information</b>",
            answer: `<div></div>`,
            subItems: [
                {
                    id: 1.1,
                    question: "Account Dashboard Navigation",
                    answer: `
                <h3><b>Profile – Personal Details</b></h3>
                  <li><b>Change Password:</b> Update your login password.</li>
                  <li><b>Add/Update Picture:</b> Upload or change your profile picture.</li>
                  <li><b>Edit Contact Information:</b> Update your email address or phone number.</li>
              </br>
              <h3>
              <b>Orders</b>
              </h3>
                  <li><b>Order History:</b> View a list of all your past orders and tracking info.</li>
              <h3>
              <b>Subscribe & Save Orders</b></h3>
                  <li><b>Manage Subscribe & Save Orders:</b> Update any details on your subscription.</li>
              <h3><b>Addresses</b></h3>
                  <li><b>Shipping Addresses:</b> Add or update your shipping information.</li>
  
              <h3><b>Documents</b></h3>
                  <li><b>Policies and Procedures:</b> Access important documents.</li>
  
              <h3><b>Payments</b></h3>
                  <li><b>Payment Methods:</b> Add or update your payment information.</li>
  
              <h3><b>Wallet</b></h3>
                  <li><b>Commission Payments: </b> Track your monthly earnings in your Wallet.</li>
                `,
                },
                {
                    id: 1.2,
                    question: "What is a Referral Code?",
                    answer: `
               A Referral Code is a unique name or combination of letters and numbers that you share with others. It helps the company track who you referred as a customer.
                `,
                },

                {
                    id: 1.3,
                    question: "What is a Referral URL Link?",
                    answer: `
                 A Referral URL Link combines your Referral Code with a website link, like code.shopkaire.com. Share this link with potential customers to ensure they are linked to you.  You can personalize it as well for example, yourname.shopkaire.com 
                  `,
                },
                {
                    id: 1.4,
                    question: "Forgot Username",
                    answer: `
                    Your Username is your email address registered with Kaire. If you’ve changed your email and can’t remember the previous one, email us at support@kaire.com, and we’ll be happy to assist you.
                  `,
                },
                {
                    id: 1.5,
                    question: "Forgot Password",
                    answer: `
                    Click 'Forgot Password' on the login page, and we’ll email you reset instructions. Check your spam folder if it’s not in your inbox. If you don’t receive the email within 10 minutes, contact us at support@kaire.com.
                  `,
                },
                {
                    id: 1.6,
                    question: "Reset Password",
                    answer: `
                    Log in to your account, go to Profile, and click 'Change Password' below the picture area. Follow the instructions to update your password.
                  `,
                },
                {
                    id: 1.7,
                    question: "How Can I Update My Account Information?",
                    answer: `
                   
                  Log in to your account and go to the Profile section. Here, you can update your contact details, email address, and preferences. Remember to save changes.
                  `,
                },
            ],
        },
        {
            id: 2,
            question: "<b>Order Information</b>",
            answer: `
            `,
            subItems: [
                {
                    id: 2.1,
                    question: "How to Place Your First Order",
                    answer: `
                We’re excited to help you get started! Follow these steps to place your first order:<br></br>
              1. <b>Visit the Website:</b> Go to ShopKaire.com for ‘Refer a Friend’ or ShareKaire.com for ‘Affiliates’<br></br>
              2. <b>Browse Products:</b> Click "Products" at the top of the page. Select your desired products and quantity, then click "Checkout."<br></br>
               3. <b>Optional - Subscribe & Save: </b> Save on your favorite products with monthly auto-delivery at a discounted price. You can cancel anytime."<br></br>
                4. <b>Create an Account:</b> <br>
                <li>Enter your email and create a password.</li>
                <li>Add billing and shipping information.</li>
                <li>If you have a referral name or URL, enter it. If not, select "I do not have one."</li></br>     

                 5. <b>Complete Your Order:</b>
                 <li>Enter your payment details and finish the checkout process.</li>
                 <li>Receive an order number and confirmation email (check your spam folder if needed).</li>
                 <li>A tracking email will be sent when your order ships.</li></br>
                 6.<b>For Future Orders:</b> Log in with your email and password for faster checkout next time."</br>
          
                `,
                },
                {
                    id: 2.2, question: "Where is My Order?", answer: `
                    We’re sorry for the delay. Check your tracking number in your account. If there’s no progress, 
                    email us at <a href="mailto:support@kaire.com">support@kaire.com</a> with:
                   <li>Your Name</li>
                  <li>ID Number</li>
                  <li>Order Number</li>
                  <li>Date of Order</li>
                  We’ll get back to you with updates as soon as possible.` },

                { id: 2.3, question: 'How Can I Track My Order?', answer: 'Log in to your account, view your orders, and find the tracking number for your shipment. Use it to check the status of your delivery on the carrier’s website.' },

                { id: 2.4, question: 'What Payment Methods Are Accepted?', answer: 'We accept major credit cards, debit cards, and other secure payment options listed at checkout. For questions, contact <a href="mailto:support@kaire.com">support@kaire.com</a>.' },

                {
                    id: 2.5, question: 'My Credit Card is not processing?', answer: `If your credit card is not processing to place your order.  Some possibilities for this could be:
                      <li>If your credit card number is saved on your account, does it need updating?  </li>
                      <li>Does your billing address match what your credit card statement shows?</li>
                      <li>For security purposes, your bank could be suspicious of your new transaction and wish you to verify either by a text, email or call the number on the back of your card to verify this transaction.</li>
                      <li>Sometimes you just have to reenter your card number on your account again and save it.</li>
                      `},

                { id: 2.6, question: "Update Monthly Subscribe & Save", answer: "Log in to your account and navigate to Subscribe & Save Orders. Here, you can update billing and shipping addresses, modify products, change the next shipping date, and update payment information. Remember to click 'Update' to save changes." },

                { id: 2.7, question: 'How Can I Cancel my Subscribe & Save Monthly Order?', answer: 'Orders can be canceled a few days before shipping. Login to your account with your email and password. Click on Subscribe & Save in your Dashboard. Under Actions, click the trashcan.' },

                {
                    id: 2.8, question: 'Missing or Damaged Item in My Order', answer: `If an item is missing or damaged, email us at <a href="mailto:support@kaire.com">support@kaire.com</a> with:
                          <li>Your Name</li>
                          <li>ID Number</li>
                          <li>Order Number</li>
                          <li>Date of Order</li>
                          <li>Details of the missing or damaged item (include a photo if possible).</li>
                          Please report any issues within 30 days of the delivery date. Refunds or exchanges cannot be processed after this time.
                `},

                {
                    id: 2.9, question: 'Refunds and Returns Policy', answer: `
                    <p>If within the first ninety (90) days you are not satisfied with the product, please contact support@kaire.com to initiate a return with a Return Merchandise Number (RMA#).  Returned product should be shipped to the address provided in the Return Procedures emailed from Kaire Support.  Once we receive the returned items, we'll process a refund for the product cost, excluding shipping charges, as per our return policy. The return shipping will be at your expense.</p>

                    <p>Kaire’s Refund Policy is not available to products that Customer’s purchase from anyone other than products purchased directly from Kaire.</p>
                    <p>All returns must be shipped to Kaire pre-paid, as Kaire does not accept shipping collect packages. Kaire recommends shipping returned product by UPS or FedEx which includes tracking information and insurance, as risk of loss or damage in the shipping process of the returned product shall be borne solely by the Customer. If the returned product is not received at the address provided on the RMA, it is the responsibility of the Customer to trace the shipment of the product wherein no credit will be applied.</p>
                    <p>All purchases are charged and refunded in U.S. Dollars.  All returns, refunds and exchanges will also be refunded or exchanged in U.S. Dollars.  Kaire is not responsible for fluctuating exchange rates.</p>
                `},
            ],
        },

        {
            id: 3,
            question: "<b>Product Information</b>",
            answer: `<div></div>`,
            subItems: [
                {
                    id: 3.1,
                    question: "The Difference between Super Prime120 and Maritime Prime 180",
                    answer: `
                <p>The following is the difference between Maritime Prime 180 and Super Prime 120:</p>
                  <li><b>Maritime Prime 180</b> contains 20 mg tablets, with 180 tablets in each bottle.</li>
                  <li><b>Super Maritime Prime 120</b> contains 60 mg tablets, with 120 tablets in each bottle.</li>
              </br>
             <p>Both products use the same formula. The difference lies in the tablet size and quantity. For those who prefer taking fewer tablets, the 60 mg size can be a convenient option, especially if you’re aiming for 1 mg per pound of body weight. That’s why we created this option for added flexibility. Our Pycnogenol is Kosher and Gluten Free.</p>
                `,
                },
                {
                    id: 3.2,
                    question: "Why is Maritime Prime Pycnogenol more effective than all the other brands?",
                    answer: `
               <p>Our Maritime Prime Pycnogenol does not contain inexpensive fillers as other brands have.  Our proprietary blend incorporates only the finest plant-based ingredients and enzymes to enhance the effectiveness and absorption and are certified Kosher and Gluten Free.</p>
               <p>Please review our site at shopkaire.com as it has a lot of great information and reviews that might interest you.  Our Maritime Prime (20 mg tablets) and Super Maritime Prime (60 mg tablets) have been our flagship products for the past 32+ years. </p>
                `,
                },

                {
                    id: 3.3,
                    question: "Does Maritime Prime Pycnogenol have any fillers?",
                    answer: `
                 Our Maritime Prime Pycnogenol does not contain inexpensive fillers as other brands have.  Our proprietary blend incorporates only the finest plant-based ingredients and enzymes to enhance the effectiveness and absorption and are certified Kosher and Gluten Free.
                  `,
                },

            ],
        },
        // other FAQ items
    ];


    return (
        <FaqStyle>
            <div className='faq-wrapper'>
                <div className="container">
                    <div className='inner-div'>
                        <h2>FAQ'S</h2>

                        {faqs.map((faq) => (
                            <Accordion
                                key={faq.id}
                                expanded={expanded === faq.id}
                                onChange={handleMainChange(faq.id)}
                            >
                                <AccordionSummary
                                    expandIcon={expanded === faq.id ? "-" : "+"}
                                    aria-controls={`panel${faq.id}-content`}
                                    id={`panel${faq.id}-header`}
                                >
                                    <Typography><div className="place-order" dangerouslySetInnerHTML={{ __html: faq.question }}></div></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography
                                        component="div"
                                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                                        className="faq-answer place-order"
                                    />

                                    {faq.subItems && (
                                        <div className="sub-accordions ">
                                            {faq.subItems.map((subItem) => (
                                                <Accordion
                                                    key={subItem.id}
                                                    expanded={subExpanded[faq.id] && subExpanded[faq.id][subItem.id]}
                                                    onChange={handleSubChange(faq.id, subItem.id)}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={subExpanded[faq.id] && subExpanded[faq.id][subItem.id] ? "-" : "+"}
                                                        aria-controls={`panel${subItem.id}-content`}
                                                        id={`panel${subItem.id}-header`}
                                                    >
                                                        <Typography><div className="place-order">{subItem.question}</div></Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Typography
                                                            component="div"
                                                            dangerouslySetInnerHTML={{ __html: subItem.answer }}
                                                            className="faq-answer place-order"
                                                        />
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))}
                                        </div>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                </div>
            </div>
        </FaqStyle>
    );
};

export default Faq;
